import { render, staticRenderFns } from "./hr.vue?vue&type=template&id=47924afc&scoped=true&"
import script from "./hr.vue?vue&type=script&lang=js&"
export * from "./hr.vue?vue&type=script&lang=js&"
import style0 from "./hr.vue?vue&type=style&index=0&id=47924afc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47924afc",
  null
  
)

export default component.exports